import isEmpty from 'lodash/isEmpty';
import env from 'env/env';

const mapMetaData = ({ seoQuestion, seoAnswer }) => {
  if (seoQuestion && seoAnswer) {
    return {
      '@type': 'Question',
      name: seoQuestion,
      acceptedAnswer: {
        '@type': 'Answer',
        text: seoAnswer,
      },
    };
  }

  return undefined;
};

const getChildComponents = (components = []) =>
  components.reduce((accumulator, { childComponents = [], metaData, fragmentData }) => {
    // the api always returns an empty array, however we might be less accurate in setting up the stubs.
    const metaDataFromChildren = getChildComponents(childComponents);

    return [...accumulator, metaData, fragmentData?.metaData, ...metaDataFromChildren];
  }, []);

export const getJsonLd = components => {
  const arrayMetaData = getChildComponents(components).filter(x => x);
  if (isEmpty(arrayMetaData)) return null;

  const mainEntity = arrayMetaData.map(mapMetaData).filter(x => x);

  if (!mainEntity.length) return null;

  return {
    '@context': 'http://schema.org/',
    '@type': 'FAQPage',
    mainEntity,
  };
};

export const getBreadcrumbsJsonLd = (breadcrumbs, pageTitle) => {
  if (!breadcrumbs) return undefined;

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      ...breadcrumbs.map(({ name, path: breadcrumbPath }, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name,
        item: `${env.clientHost}${breadcrumbPath}`,
      })),
      {
        '@type': 'ListItem',
        position: breadcrumbs.length + 1,
        name: pageTitle,
      },
    ],
  };
};
